import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { PillButtonPage } from '../../../../shared/pages/PillButtonPage'
import { ToolContext } from '../../../../shared/state/appContext'
import globalStyles from '../../../../shared/styles/GlobalStyles.module.scss'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import {
  DelayedCancelledFlow,
  HoursDifferenceFlow,
  TimeBeforeCancelledFlow,
} from '../../pageFlowData'
import { data } from './data'

export const DelayedOrCancelled: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    flight: { delayedCancelled },
  } = state

  const handleStepChoice = (value: string) => {
    if (value === 'flight-delayed') {
      return { progress: HoursDifferenceFlow.PROGRESS_VALUE, step: HoursDifferenceFlow.STEP }
    }

    return { progress: TimeBeforeCancelledFlow.PROGRESS_VALUE, step: TimeBeforeCancelledFlow.STEP }
  }

  const handleDispatch = (value: string) => {
    const { progress, step } = handleStepChoice(value)

    dispatch({ type: 'UPDATE_DELAYED_CANCELLED', data: value })
    dispatch({ type: 'UPDATE_STEP', data: step })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: progress })
  }

  const handleTracking = (value: string) => {
    const trackingAnswer = `question | ${DelayedCancelledFlow.VIEW_NAME} | ${value}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleSubmit = (id: string) => {
    handleDispatch(id)
    handleTracking(id)
  }

  const { buttons, imgObj, title } = data

  return (
    <>
      <div className={globalStyles.fullWidthButton} data-testid="delayed-or-cancelled">
        <PillButtonPage
          buttons={buttons}
          defaultValue={delayedCancelled}
          fitContent
          handleSubmit={handleSubmit}
          imgObj={imgObj}
          title={title}
        />
      </div>
    </>
  )
}
